import { Latin } from '../../../core/languages/Latin';
import { runPreprocessing } from '../compounded/CompoundedInterpreter';
import { SeparatedViewSeparator } from './converter.core';
import { IsClef } from './gabcExceptions';

const latin = new Latin();

export function from_compounded_to_separated(input: string): {
  lyrics: string,
  gabc: string,
  nabc?: string,
  metadata?: string,
} {
  const result = runPreprocessing(input);
  const gnabc = result.gnabc;

  const lyrics: string[] = [];
  const gabc: string[] = [];
  const nabc: string[] = [];
  let mode = 'lyrics';

  let lyricsBuffer = '';
  let gabcBuffer = '';
  let nabcBuffer = '';

  let newWord = true;

  let i = 0;
  while (i < gnabc.length) {
    const char = gnabc[i];

    if (char === '(') {
      if (!lyricsBuffer) {
        const buffer = read_forward(gnabc, i + 1);
        if (!IsClef(buffer)) {
          push_buffer_lyrics(lyrics, '()', !newWord);
        }
      } else {
        push_buffer_lyrics(lyrics, lyricsBuffer, !newWord);
      }
      lyricsBuffer = '';
      newWord = false;
      if (gnabc[i + 1] === '|') {
        gabcBuffer += '()' + SeparatedViewSeparator;
        mode = 'nabc';
        i++;
      } else {
        mode = 'gabc';
      }
    } else if (char === ')') {
      if (gabcBuffer === '') {
        push_buffer(gabc, '()');
      } else {
        push_buffer(gabc, gabcBuffer);
      }

      if (nabcBuffer) {
        push_buffer(nabc, nabcBuffer);
      } else if (!IsClef(gabcBuffer)) {
        push_buffer(nabc, '()');
      }

      gabcBuffer = '';
      nabcBuffer = '';

      if (gnabc[i + 1] === ' ' || gnabc[i + 1] === '\t' || gnabc[i + 1] === '\n' || gnabc[i + 1] === undefined) {
        push_buffer_lyrics(lyrics, lyricsBuffer, !newWord);
        lyricsBuffer = '';
        newWord = true;
        i++;
      }
      mode = 'lyrics';
    } else if (char === '|') {
      const next_char = gnabc[i + 1];
      if (next_char === '|' || next_char === ')') {
        if (mode === 'gabc') {
          nabcBuffer += '()' + SeparatedViewSeparator;
          gabcBuffer += SeparatedViewSeparator;
        } else if (mode === 'nabc') {
          gabcBuffer += '()' + SeparatedViewSeparator;
          nabcBuffer += SeparatedViewSeparator;
        }
        if (next_char === '|') {
          i++;
        }
      } else {
        if (mode === 'gabc') {
          gabcBuffer += SeparatedViewSeparator;
          mode = 'nabc';
        } else if (mode === 'nabc') {
          nabcBuffer += SeparatedViewSeparator;
          mode = 'gabc';
        }
      }
    } else {
      switch (mode) {
        case 'lyrics':
          lyricsBuffer += char;
          break;
        case 'gabc':
          gabcBuffer += char;
          break;
        case 'nabc':
          nabcBuffer += char;
          break;
      }
    }

    i++;
  }

  if (lyricsBuffer) {
    push_buffer_lyrics(lyrics, lyricsBuffer, !newWord);
  }

  return {
    lyrics: lyrics.join(' '),
    gabc: gabc.join(' '),
    nabc: nabc.join(' '),
    metadata: result.metadata,
  };
}

function push_buffer_lyrics(buffer_arr: string[], buffer: string, appendPrevWord: boolean) {
  if (!buffer) {
    return;
  }

  let _buffer = buffer;

  if (_buffer.includes(' ') || _buffer.includes('<') || latin.syllabifyWord(_buffer).length > 1) {
    _buffer = '(' + _buffer + ')';
  }

  if (appendPrevWord && buffer_arr.length > 0) {
    buffer_arr[buffer_arr.length - 1] += _buffer;
  } else {
    buffer_arr.push(_buffer);
  }
}

function push_buffer(buffer_arr: string[], buffer: string) {
  if (!buffer) {
    return;
  }

  let _buffer = buffer;

  if (_buffer.endsWith(SeparatedViewSeparator)) {
    _buffer = _buffer.slice(0, -1);
  }

  if (_buffer.includes(' ') || _buffer.includes('<')) {
    _buffer = '(' + _buffer + ')';
  }

  buffer_arr.push(_buffer);
}

function read_forward(text: string, startIndex: number): string {
  let buffer = '';
  let i = startIndex;
  while (i < text.length) {
    const char = text[i];
    if (char === ' ' || char === ')' || char === '|') {
      break;
    } else {
      buffer += char;
    }
    i++;
  }
  return buffer;
}
